/* JI presentation hooks; native Impulse 10 owns selection, fetching and form state. */
(() => {
  if (window.jiV10IntegrationLoaded) return;
  window.jiV10IntegrationLoaded = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ji-v10-value]');
    if (!button) return;
    const select = button.closest('[data-ji-v10-option]')?.querySelector('select[data-option-name]');
    if (!select || !Array.from(select.options).some(option => option.value === button.dataset.jiV10Value)) return;
    select.value = button.dataset.jiV10Value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('kit:variant-picker:after-change', event => {
    const root = event.target.closest('[data-section-type="product"]');
    const variant = event.detail?.variant;
    if (!root || !variant || !Number.isFinite(variant.price)) return;
    root.querySelectorAll('[id*="afterpay_on_site_messaging"] square-placement[data-platform="shopify-app-blocks"]').forEach(placement => {
      placement.setAttribute('data-amount', (variant.price / 100).toFixed(2));
    });
  });
})();
